import { POPULAR_TEAM_COLORS } from '../constants/teamForm';

const ColorPaletteModal = ({ isOpen, onClose, onSelectColor }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="color-palette-overlay" onClick={onClose}>
      <div className="color-palette-modal" onClick={(event) => event.stopPropagation()}>
        <div className="color-palette-header">
          <h3>Выберите цвет команды</h3>
          <button className="color-palette-close" onClick={onClose} type="button">
            ✕
          </button>
        </div>
        <div className="color-palette-content">
          <div className="color-grid">
            {POPULAR_TEAM_COLORS.map((colorItem) => (
              <button
                key={colorItem.color}
                type="button"
                className="color-option"
                style={{ backgroundColor: colorItem.color }}
                onClick={() => onSelectColor(colorItem.color)}
                title={colorItem.name}
              >
                <span className="color-name">{colorItem.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorPaletteModal;
